// extracted by mini-css-extract-plugin
module.exports = {"root":"widgetPromotion_root___fEEF","cardRoot":"widgetPromotion_cardRoot__m70kb","cardContent":"widgetPromotion_cardContent__CS5lO","subtitle":"widgetPromotion_subtitle__NWemi"};